export default __webpack_public_path__ + "static/Capriola-Regular-9f002d350450fa5f4db1e84cc797f4fc.ttf";